import React from 'react';

export const Aux = props => <div id={props.id} className={props.className || ''}>{props.children}</div>;

export const Heading1 = props => <h1 className={props.className || ''}>{props.children}</h1>;

export const Heading2 = props => <h2 className={props.className || ''}>{props.children}</h2>;

export const Heading3 = props => <h3 className={props.className || ''}>{props.children}</h3>;

export const Heading4 = props => <h4 className={props.className || ''}>{props.children}</h4>;

export const Heading5 = props => <h5 className={props.className || ''}>{props.children}</h5>;

export const Heading6 = props => <h6 className={props.className || ''}>{props.children}</h6>;

export const Icon = props =>
	<i
		aria-hidden={props.ariaHidden}
		title={props.title}
		className={`${props.face || ''}  ${props.className || ''}`}
		onClick={props.onClick}>
		{props.children}
	</i>;

export const Small = props => <small className={`${props.face}  ${props.className || ''}`} onClick={props.onClick}>{props.children}</small>;

export const Span = props => <span data-placeholder={props.dataPlaceholder}
	className={`${props.face}  ${props.className || ''}`} onClick={props.onClick}>{props.children}</span>;

export const Image = props => <img src={props.src} alt={props.alt} onClick={props.onClick}></img>;

export const TitleIcon = props => <i className={`mr-2 ${props.className || ''}`}>{props.children}</i>;

export const Beta = ({ className }) => <sub className={`beta ${className || ''}`}>Beta</sub>;

export const ChatCount = ({ className, count }) => <div className={`chatCount ${className || ''}`}>{count}</div>;